import { propertiesSelectorCreator } from './propertiesSelector';
import { subselect } from './root';

export const propertiesSelector = propertiesSelectorCreator();

export const viralPropertiesSelector = subselect(propertiesSelector);
